<div
  *ngIf="domOpen"
  #overlayRoot
  class="v2-add-multiple-items"
  [class.v2-add-multiple-items--closing]="isClosing"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'ADD_MULTIPLE_ITEMS_TITLE' | translate"
>
  <!-- Floating chrome — same pattern as v2-album-overlay (.v2-ao-close / .v2-ao-title-pill) -->
  <button
    type="button"
    class="v2-am-ao-close"
    (click)="onHeaderBack()"
    [attr.aria-label]="'BUTTON_CLOSE' | translate"
  >
    ×
  </button>

  <div class="v2-am-ao-title-pill" aria-hidden="true">
    {{ 'ADD_MULTIPLE_ITEMS_TITLE' | translate }}
  </div>

  <div class="v2-am-floating-progress" *ngIf="saving">
    <div class="v2-am-progress-native" role="progressbar" aria-busy="true">
      <div class="v2-am-progress-native__bar"></div>
    </div>
  </div>

  <div class="v2-add-multiple-items-main">
    <div class="manage-content v2-add-multiple-items-scroll">
      <div
        class="manage-wrapper v2-am-wrap"
        [class.opened]="contentReveal"
        [class.loaded]="contentReveal"
      >
        <div class="v2-ami">
          <section class="v2-ami-panel v2-ami-panel--intro">
            <p class="v2-ami-lead">{{ 'ADD_MULTIPLE_ITEMS_TEXT' | translate }}</p>
          </section>

          <section class="v2-ami-panel">
            <span class="v2-ami-section-label">{{ 'INSERT_ITEMS' | translate }}</span>
            <div class="v2-ami-textarea-wrap">
              <textarea
                class="v2-ami-textarea"
                rows="5"
                [placeholder]="'INSERT_ITEMS_TEXT' | translate"
                [(ngModel)]="itemIdsToAdd"
                (input)="listChanged()"
              ></textarea>
            </div>
            <div class="v2-ami-btn-wrap">
              <app-btn
                class="v2-ami-add-btn"
                icon="add"
                [text]="'ADD_ENTRY_ADD' | translate"
                [type]="itemIdsToAdd === '' ? 'disabled' : 'neutral'"
                (clicked)="addItems()"
              ></app-btn>
            </div>
          </section>

          <section *ngIf="itemsToAdd?.length > 0" class="v2-ami-metrics" role="status">
            <div class="v2-ami-metric">
              <span class="v2-ami-metric-label">{{ 'TOTAL_ITEMS_TO_ADD' | translate }}</span>
              <span class="v2-ami-metric-value">{{ totalItemsToAdd }}</span>
            </div>
            <div class="v2-ami-metric">
              <span class="v2-ami-metric-label">{{ 'NEW_ITEMS_TO_ADD' | translate }}</span>
              <span class="v2-ami-metric-value">{{ totalItemsToAddNew }}</span>
            </div>
          </section>

          <section *ngIf="itemsToAdd?.length > 0" class="v2-ami-list">
            <div *ngFor="let item of itemsToAdd" class="v2-ami-item-card">
              <div class="v2-ami-item-body">
                <div class="v2-ami-item-title-row">
                  <p class="v2-ami-item-id">{{ item.item_id }}</p>
                  <p class="v2-ami-item-name">{{ item.item_name }}</p>
                </div>
                <p class="v2-ami-item-meta v2-ami-item-meta--warn" *ngIf="item.Tenho">
                  {{ 'QUANTITY_IN_COLLECTION' | translate }} {{ item.tot }}
                </p>
                <p class="v2-ami-item-meta v2-ami-item-meta--new" *ngIf="!item.Tenho">
                  {{ 'NEW_ITEM' | translate }}
                </p>
                <p class="v2-ami-item-qty">{{ 'QUANTITY_TO_ADD' | translate }} {{ item.addQuantity }}</p>
              </div>
              <app-btn
                class="v2-ami-item-remove-btn"
                icon="remove-circle"
                type="danger"
                (clicked)="removeItem(item)"
              ></app-btn>
            </div>
          </section>
        </div>
      </div>
    </div>

    <footer class="v2-ami-footer">
      <app-btn
        class="v2-ami-footer-save-host"
        icon="checkmark-circle"
        [text]="'SAVE_ITEMS' | translate"
        [type]="notValidated || saving ? 'disabled' : 'primary'"
        (clicked)="onSave()"
      ></app-btn>
    </footer>
  </div>
</div>
